import { useState } from "react";
import {
  cadastrarAndamentoCompatibilidadeService,
  CadastrarAndamentoCompatibilidadePayload,
} from "../../../services/cadastrarAndamentoCompatibilidadeService";

export const useCadastrarAndamentoCompatibilidade = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const cadastrar = async (
    compatibilidadeId: number,
    data: CadastrarAndamentoCompatibilidadePayload
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await cadastrarAndamentoCompatibilidadeService(
        compatibilidadeId,
        data
      );

      if (response) {
        setSuccess("Anotação registrada com sucesso!");
      } else {
        setError("Não foi possível registrar a anotação. Tente novamente.");
      }
    } catch (error) {
      setError("Não foi possível registrar a anotação. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
